import "./styles.css"

export function EsportsPlayer({ videoUrl }: { videoUrl?: string }) {
  return (
    <div className="esports-player column__wide">
      {videoUrl ? (
        <iframe
          title="esports"
          id="ytplayer"
          width="100%"
          height="100%"
          src={videoUrl}
          style={{ border: 0 }}
        />
      ) : null}
    </div>
  )
}

export default EsportsPlayer
